import React from 'react';
import SData from "../../helpers/SData";
import {CheckOutlined, ClockCircleOutlined, ToolOutlined} from "@ant-design/icons";
import Card from "../views/Card";
import "./TaskItem.less";
import {Empty} from "antd";
import SystemFunctions from "../../helpers/SystemFunctions";
import TimeLogic from "../../helpers/TimeLogic";

class DashboardStats extends React.Component {

    updateInterval = null;

    componentDidMount() {
        this.removeUpdater();
        this.updateInterval = setInterval(() => {
            this.forceUpdate();
        }, 3000);
    }

    componentWillUnmount() {
        this.removeUpdater();
    }

    removeUpdater = () => {
        if (this.updateInterval != null) {
            clearInterval(this.updateInterval);
            this.updateInterval = null;
        }
    }

    constructor(props, context) {
        super(props, context);

        this.state = {
            fullDescTask: false,
            taskCheckbox: false,
        };
    }

    render() {
        if (SData.base.purpose == null || SData.base.purpose.status !== 2) {
            let content = <Empty image={<ToolOutlined/>} description='Вы находитесь в режиме редактирования цели'/>;
            if (SData.base.purpose != null) {
                switch (SData.base.purpose.status) {
                    case 1:
                        content = <Empty image={<ClockCircleOutlined/>} description='Цель отправлена на утверждение'/>;
                        break;
                    case 3:
                        content = <Empty image={<CheckOutlined/>} description='Цель полностью завершена!'/>;
                        break;
                }
            }
            return <Card className='editModeStats'>
                {content}
            </Card>;
        }
        const tasks = SData.tasks;
        let purposeAll = tasks.length;
        let purposeCompleted = 0;
        for (let i = 0; i < tasks.length; i++) {
            if (tasks[i].status === 0) {
                break;
            }
            purposeCompleted++;
        }
        let curTime = Math.floor(TimeLogic.getDate().getTime() / 1000);
        let work = curTime - SData.base.data.day.start_work;
        if (SData.base.purpose.status !== 2 || SData.base.status === 0) {
            work = 0;
        }
        let workNeed = SData.base.data.dayNeed.work;
        let workPercent = work / workNeed;
        let breaks = SData.base.data.day.breaks;
        if (SData.base.purpose.status === 2 && SData.base.status === 2) {
            breaks += curTime - SData.base.data.day.last_break;
        }
        if (SData.base.purpose.status !== 2 || SData.base.status === 0) {
            breaks = 0;
        }
        let breaksNeed = SData.base.data.dayNeed.breaks;
        let breaksPercent = breaks / breaksNeed;
        let dt = SData.base.data.day.tasks;
        let dtNeed = SData.base.data.dayNeed.tasks;
        let dtPercent = dt / dtNeed;
        let scores = SData.base.data.day.scores;
        let scoresNeed = SData.base.data.dayNeed.scores;
        let scoresPercent = scores / scoresNeed;
        return (<div className='statCards'>
            <Card className='dayProgress n0 blue'>
                <div className='content'>
                    <div className='title'>Рабочий день</div>
                    <div className='value'>{SystemFunctions.secondsToTextClockTimeout(work)} <span
                        className='dim'>/ {SystemFunctions.secondsToTextClockTimeout(workNeed)}</span></div>
                </div>
                <div style={{width: (workPercent * 100) + '%'}} className='bgProgress blue'/>
            </Card>
            <Card className='breaks n1 red'>
                <div className='content'>
                    <div className='title'>Перерывы</div>
                    <div className='value'>{SystemFunctions.secondsToTextClockTimeout(breaks)} <span
                        className='dim'>/ {SystemFunctions.secondsToTextClockTimeout(breaksNeed)}</span></div>
                </div>
                <div style={{width: (breaksPercent * 100) + '%'}} className='bgProgress red'/>
            </Card>
            <Card className='completedCount n2 orange'>
                <div className='content'>
                    <div className='title'>Выполнено задач</div>
                    <div className='value'>{dt} <span className='dim'>/ {dtNeed}</span></div>
                </div>
                <div style={{width: (dtPercent * 100) + '%'}} className='bgProgress orange'/>
            </Card>
            <Card className={'dayScores n3 ' + (scoresPercent >= 0 ? 'green' : 'red')}>
                <div className='content'>
                    <div className='title'>Баллы</div>
                    <div className='value'>{scores >= 0 ? ('+ ' + scores) : ('- ' + Math.abs(scores))}</div>
                </div>
                <div style={{width: (Math.abs(scoresPercent) * 100) + '%'}}
                     className={'bgProgress ' + (scoresPercent >= 0 ? 'green' : 'red')}/>
            </Card>
            <Card className='tasksLeft n4 orange'>
                <div className='content'>
                    <div className='title'>Цель</div>
                    <div className='value'>{purposeCompleted} <span className='dim'>/ {purposeAll}</span></div>
                </div>
                <div style={{width: (purposeCompleted / purposeAll * 100) + '%'}} className='bgProgress orange'/>
            </Card>
            <Card className='developersOnline n5 blue'>
                <div className='content'>
                    <div className='title'>В сети</div>
                    <div className='value'>{SData.base.online}</div>
                </div>
                <div style={{width: (SData.base.online / SData.base.countUsers * 100) + '%'}}
                     className='bgProgress blue'/>
            </Card>
        </div>);
    }
}

DashboardStats.propTypes = {};

export default DashboardStats;